import script from "./QueryTemplatePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryTemplatePanel.vue?vue&type=script&setup=true&lang=js"

import "./QueryTemplatePanel.vue?vue&type=style&index=0&id=4b631db3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b631db3"]])

export default __exports__